import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

function SeoHead() {
  useEffect(() => {
    api.get("/seo/settings").then((r) => {
      const code = r.data?.gsc_verification_code;
      if (code) {
        let el = document.querySelector('meta[name="google-site-verification"]');
        if (!el) { el = document.createElement("meta"); el.setAttribute("name", "google-site-verification"); document.head.appendChild(el); }
        el.setAttribute("content", code);
      }
    }).catch(() => {});
  }, []);
  return null;
}

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import NumberDetail from "@/pages/NumberDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import SeoTools from "@/pages/SeoTools";
import ShortRedirect from "@/pages/ShortRedirect";
import PublicSite from "@/pages/PublicSite";
import NotFound from "@/pages/NotFound";

function Protected({ children, admin }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-slate-400">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <BrowserRouter>
      <SeoHead />
      <Routes>
        <Route path="/" element={withLayout(<Home />)} />
        <Route path="/numara/:number" element={withLayout(<NumberDetail />)} />
        <Route path="/seo-araclari" element={withLayout(<SeoTools />)} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Protected>{withLayout(<Dashboard />)}</Protected>} />
        <Route path="/adc" element={<Protected admin>{withLayout(<Admin />)}</Protected>} />
        <Route path="/s/:code" element={<ShortRedirect />} />
        <Route path="/:slug" element={<PublicSite />} />
        <Route path="*" element={withLayout(<NotFound />)} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
